<div class="component-container">
  <div class="container">
    <div class="icon-wrapper">
      <div class="icon">
        <svg fill="none" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/>
        </svg>
      </div>
    </div>

    <h1>Account Disabled</h1>
    <p *ngIf="disabled">Your account has been temporarily disabled. This may be due to a violation of our terms of service or suspicious activity detected on your account.</p>
    <p *ngIf="!disabled">Your account has been restored. You may resume normal activity.</p>
    <button class="button" (click)="checkStatus()">Check Account Status</button>

    <p class="support-text">
      Need help? <a href="mailto:support@avsemprize.com">Contact Support</a>
    </p>
  </div>

  
</div>